export type {
  ModalRefOption,
  ModalModalOptions,
  ModalAction,
  ModalType,
  BuiltinModalType,
  ExtendedModalType,
  ModalTypeRegistry,
  ModalTypeItem,
  ModalTypeMap,
  BuiltinModalTypeMap,
  MergeableModalTypeMap,
  MergeModalTypeInput,
  ModalPropsTypeMap,
  ModalRefProps,
  ModalRefData,
  ModalCustomMap,
  ExtractCustomMap,
  ResolveCustomMap,
  ExtractVisibleKey,
  ResolveVisibleKey,
  ResolveHookOptions,
  ModalRef,
  ModalResult,
  ModalData,
  ModalVisibleProps,
  UseCommonRefReturn,
  ModalRefDynamic,
  ModalBeforeCloseHandler,
  ModalBeforeEndHandler,
  ModalBeforeCancelHandler,
} from './types/modal';

export { mergeModalType } from './constants/modalTypes';
export { default } from './hooks/useCommonRef';
export { default as useCommonRef } from './hooks/useCommonRef';
